import { create, all } from "mathjs";
import {
  DATEDIF,
  DATEFORMAT,
  PERCENT,
  STATISTICAL_MEAN,
  STATISTICAL_MEDIAN,
  STATISTICAL_MODE,
  STATISTICAL_SUM,
} from "@utils/getFormulaValue.util";
const math = create(all);
math.import({
  DATEDIF,
  PERCENT,
  DATEFORMAT,
  STATISTICAL_SUM,
  STATISTICAL_MEAN,
  STATISTICAL_MEDIAN,
  STATISTICAL_MODE,
});

export { math as mathlib };
